import { render, staticRenderFns } from "./AmountOwedModel.vue?vue&type=template&id=d40ed800&"
import script from "./AmountOwedModel.vue?vue&type=script&lang=js&"
export * from "./AmountOwedModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports